import React, { useRef, useState } from 'react'
import { Button, ListMenu, ListMenuButton, Popover, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useParams, useRouteMatch } from 'react-router-dom'
import { MoreIcon } from 'assets/icons'
import { useOrganization } from 'src/graphql/hooks'

const ProfileMoreButton = ({ color, iconColor }) => {
   const { userId } = useParams()
   const match = useRouteMatch()

   const popoverButton = useRef()
   const [popoverIsOpen, setPopoverIsOpen] = useState(false)
   const { organization } = useOrganization()
   const showAdminActions = organization.currentUserCanEdit && userId !== 'me'
   const showMyActions = userId === 'me'

   if (!organization.currentUserCanEdit && userId !== 'me') {
      return null
   }

   const adminActionButtons = [{
      linkTo: `${match.url}/ban-user`,
      name: 'Ban this user'
   }]

   const myActionButtons = [{
      linkTo: `${match.url}/login-history`,
      name: 'View Login History'
   }]

   return (
      <View>
         <Button
            ref={popoverButton}
            color="#e5e5e5"
            onClick={() => setPopoverIsOpen(true)}
            size="md"
            width="36px">
            <MoreIcon width="18px" height="18px" color={iconColor} />
         </Button>
         <Popover
            anchorElement={popoverButton.current}
            anchorOriginHorizontal={showMyActions ? 'right' : 'left'}
            anchorOriginVertical="top"
            borderRadius="6px"
            width="180px"
            onBodyClick={() => setPopoverIsOpen(false)}
            open={popoverIsOpen}>
            <View
               float="left"
               width="100%"
               borderRadius="6px"
               margin="12px 0px"
               backgroundColor="#fff"
               border="1px solid #eee"
               boxShadow="6px 6px 30px rgba(0,0,0,0.1)">
               <View
                  float="left"
                  width="100%">
                  <ListMenu buttonSize="md" dividerLineStyle="none">
                     {showAdminActions && adminActionButtons.map(button => (
                        <ListMenuButton
                           key={button.name}
                           linkTo={button.linkTo}
                           name={button.name}
                        />
                     ))}
                     {showMyActions && myActionButtons.map(button => (
                        <ListMenuButton
                           key={button.name}
                           linkTo={button.linkTo}
                           name={button.name}
                        />
                     ))}
                  </ListMenu>
               </View>
            </View>
         </Popover>
      </View>
   )
}

ProfileMoreButton.propTypes = {
   color: PropTypes.string,
   iconColor: PropTypes.string
}

ProfileMoreButton.defaultProps = {
   color: '#eee',
   iconColor: '#444'
}

export default ProfileMoreButton
